<template>
  <div class="app-go-to-top" @click="goToTop()" title="Go to Top">
    <i class="fa fa-arrow-up" title="Go to Top"></i>
  </div>
</template>

<script>
export default {
  methods: {
    goToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.app-go-to-top,
.app-go-to-top i {
  cursor: pointer;
  height: 60px;
  width: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 32px;
  color: #fff;
}

.app-go-to-top {
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 10;
  background-color: #00000033;
  border-radius: 50%;
}

@media (min-width: 1068px) {
  .app-go-to-top,
  .app-go-to-top i {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
  }
}
</style>
